import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@ordo/ui/alert-dialog'

/**
 * Asked before a chef prints a packet whose orders can still change
 * (PROD-1452). Printing is never blocked (chefs printed from the browser when
 * it was), only confirmed. `onConfirm` runs inside the confirm button's own
 * tap, so a print that needs user activation (the iOS share sheet) still has it.
 */
export function PreliminaryPrintConfirm({
  open,
  onOpenChange,
  locksAtLabel,
  onConfirm,
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
  /** When the counts lock ("Fri, Oct 9, 11:59 PM PDT"). */
  locksAtLabel: string | null
  onConfirm: () => void
}) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>These orders aren&apos;t final yet</AlertDialogTitle>
          <AlertDialogDescription>
            Schools can still change quantities until {locksAtLabel}. The printout will be watermarked &ldquo;Incomplete
            order&rdquo;. Print again once orders lock.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>Print preliminary copy</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
